import { useFormContext } from 'react-hook-form';
import type { FormFieldDef } from '../../../types';
import {
  areVisibilityConditionsMet,
  getDependentFieldIds,
} from '../../../utils/visibility';

export const useGetShowCondition = (conditions: FormFieldDef['conditions']) => {
  const formContext = useFormContext();

  if (!conditions) {
    return true;
  }

  const dependentFieldIds = getDependentFieldIds(conditions);
  const watchedFormFields = formContext.watch(dependentFieldIds);

  const valueByFieldId = Object.fromEntries(
    dependentFieldIds.map((fieldId, index) => [
      fieldId,
      watchedFormFields[index],
    ])
  );

  return areVisibilityConditionsMet(conditions, valueByFieldId);
};
